import React from "react"

export default function Team({ data }) {
  const items = data?.allPrismicMainPageBodyTeam.nodes[0].items
  const advisoryitems = data?.allPrismicMainPageBodyTeam.nodes[1].items
  return (
    <section id="our-team">
      <h1>notre équipe</h1>
      <ul className="team dalti">
        <h2>
          <span>Our Team</span> | Dalti Solution
        </h2>
        <div className="members">
          {items.map((member, index) => (
            <li key={index}>
              <img src={member.portrait.url} alt={member.portrait.alt} />
              <p>
                {member.first_and_lastname.text} -{" "}
                <span>{member.position.text}</span>
              </p>
              <p>{member.member_bg.text}</p>
            </li>
          ))}
        </div>
      </ul>
      <ul className="team advisory">
        <h2>Our Advisory</h2>
        <div className="members">
          {advisoryitems.map((member, index) => (
            <li key={index}>
              <img src={member.portrait.url} alt={member.portrait.alt} />
              <p>
                {member.first_and_lastname.text} -{" "}
                <span>{member.position.text}</span>
              </p>
              <p>{member.member_bg.text}</p>
            </li>
          ))}
        </div>
      </ul>
    </section>
  )
}
